import { text, vstack } from '@onbeam/business-styled-system/patterns';
import { DrawerFieldProps } from './DrawerField.types';

export const DrawerField = ({ title, description }: DrawerFieldProps) => (
  <div
    className={vstack({
      gap: '2',
    })}
  >
    <span className={text({ style: 'body-sm', color: 'mono.tertiary' })}>
      {title}
    </span>
    {typeof description === 'string' ? (
      <p
        className={text({
          style: 'body-md',
          color: 'mono.secondary',
          whiteSpace: 'pre-wrap',
        })}
      >
        {description}
      </p>
    ) : (
      description
    )}
  </div>
);
